import React, { useState } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { InfoOutlined } from '@material-ui/icons';
import { Checkbox, Tooltip, Badge, IconButton } from '@material-ui/core';

import { Datatable } from '../../components';
import { CompleteTradeButton } from './components/CompleteTradeButton';
import { SendSMSActions } from './components/SendSMSActions';

const PaddedBadge = withStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(2),
  },
}))(Badge);

export const TradesScheduled = ({
  data,
  sendSMS,
  sendCodeExchangeSMS,
  sendingSms,
  updateStatus,
  tradesLoading,
  toggleJobModal,
  tradesProcessing,
}) => {
  const [selected, setSelected] = useState([]);

  const tableConfig = [
    {
      heading: 'Inspect',
      key: 'id',
      headingStyles: { width: '25px' },
      formatter: (val) => (
        <IconButton
          aria-label="inspect"
          onClick={() => {
            toggleJobModal(val);
          }}
        >
          <InfoOutlined />
        </IconButton>
      ),
    },
    {
      sortable: true,
      heading: 'Status',
      key: 'status',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Participant Name',
      key: 'participantName',
      formatter: (val, row) =>
        row?.expirationCount > 0 ? (
          <span>
            {val}
            <Tooltip title="Recycle Count">
              <PaddedBadge badgeContent={row.expirationCount} color="error" />
            </Tooltip>
          </span>
        ) : (
          val
        ),
    },
    {
      sortable: true,
      heading: 'Participant ID',
      key: 'participantId',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Schedule',
      key: 'lastUpdate',
      formatter: (val) => val,
    },
    {
      heading: 'Product',
      sortable: true,
      key: 'product',
      formatter: (val) => val,
    },
    { heading: 'Type', sortable: true, key: 'type', formatter: (val) => val },
    {
      sortable: true,
      heading: 'Advisor',
      key: 'advisorName',
    },
    {
      heading: 'Send Trade',
      key: 'id',
      formatter: (val) => (
        <Checkbox
          color="primary"
          checked={selected.includes(val)}
          inputProps={{ 'aria-label': 'primary checkbox' }}
          onClick={() => {
            setSelected((prev) =>
              prev?.includes?.(val)
                ? [...prev.filter((i) => i !== val)]
                : [...prev, val]
            );
          }}
        />
      ),
    },
    {
      heading: 'Complete Trade',
      key: 'id',
      formatter: (val) => (
        <CompleteTradeButton
          jobId={val}
          loading={tradesProcessing.includes(val)}
          updateStatus={updateStatus}
        />
      ),
    },
  ];

  return (
    <Datatable
      loading={tradesLoading}
      tableHeading="Trades Scheduled"
      defaultSortColumn="created"
      defaultSortDirection="desc"
      data={data}
      tableConfig={tableConfig}
      paginationLeft={true}
      footerContent={
        <SendSMSActions
          loading={sendingSms}
          disabled={!(selected?.length > 0)}
          sendSMS={() => {
            sendSMS(selected);
            setSelected([]);
          }}
          sendCodeExchangeSMS={() => {
            sendCodeExchangeSMS(selected);
            setSelected([]);
          }}
        />
      }
    />
  );
};
